module.exports = __webpack_public_path__ + "img/lightbox-bad.52406148.svg";